import { ContextualMenu, ContextualMenuItemType, DirectionalHint, IContextualMenuItem, IContextualMenuListProps, IRenderFunction, SearchBox } from '@fluentui/react';
import React from 'react';

export interface IColumnFilterOption
{
    value: string;
    text: string;
}

export interface IColumnFilterMenuProps
{
    target: HTMLElement;
    options: IColumnFilterOption[];
    selected: string[];
    onToggle: (value: string) => void;
    onClear: () => void;
    /** Vises kun når der er aktive filtre */
    onClearAll?: () => void;
    onDismiss: () => void;
}

// Over denne grænse vises en søgeboks øverst i menuen
const SEARCH_THRESHOLD = 10;

export const ColumnFilterMenu: React.FunctionComponent<IColumnFilterMenuProps> = (props: React.PropsWithChildren<IColumnFilterMenuProps>) => {
    const [searchTerm, setSearchTerm] = React.useState<string>('');
    const showSearch = props.options.length > SEARCH_THRESHOLD;
    const term = searchTerm.toLocaleLowerCase();

    const items: IContextualMenuItem[] = [
      {
        key: 'clear',
        text: 'Ryd filter',
        iconProps: { iconName: 'ClearFilter' },
        disabled: props.selected.length === 0,
        onClick: () => { props.onClear(); }
      },
      ...(props.onClearAll ? [{
        key: 'clearAll',
        text: 'Ryd alle filtre',
        iconProps: { iconName: 'ClearFilter' },
        onClick: () => { props.onClearAll!(); }
      }] : []),
      { key: 'divider', itemType: ContextualMenuItemType.Divider },
      ...props.options
        .filter(option => term === '' || option.text.toLocaleLowerCase().indexOf(term) > -1)
        .map(option => ({
          key: `value_${option.value}`,
          text: option.text,
          canCheck: true,
          checked: props.selected.includes(option.value),
          onClick: (ev?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => {
            // Menuen holdes åben, så flere værdier kan vælges
            ev?.preventDefault();
            props.onToggle(option.value);
          }
        }))
    ];

    const onRenderMenuList: IRenderFunction<IContextualMenuListProps> = (menuListProps, defaultRender) => {
      return <div>
        {showSearch &&
          <div style={{ padding: 8, borderBottom: "1px solid #edebe9" }}>
            <SearchBox
              placeholder="Søg ..."
              underlined={true}
              value={searchTerm}
              onChange={(ev, newValue) => { setSearchTerm(newValue ?? ''); }}
            />
          </div>
        }
        <div style={{ maxHeight: 400, overflowY: "auto" }}>
          {defaultRender!(menuListProps)}
        </div>
      </div>
    }

    return <ContextualMenu
      items={items}
      target={props.target}
      directionalHint={DirectionalHint.bottomLeftEdge}
      onRenderMenuList={onRenderMenuList}
      shouldFocusOnMount={!showSearch}
      onDismiss={() => { props.onDismiss(); }}
    />
}

export default ColumnFilterMenu;
